import '@babel/polyfill';

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue, { configureCompat, createApp } from 'vue';
import VueFormGenerator from 'vue-form-generator';
import Tab from 'vue-tabs-component/src/components/Tab';
import Multiselect from 'vue-multiselect';
import VueModal from 'vue-js-modal';
import pluralize from 'pluralize';
import App from './App';
import router from './router';
import store from './store/index';
import http from './http';
import TabsCompat from './components/compat/TabsCompat';
import ThemedButton from './components/ThemedButton';
import fieldButton from './components/fields/fieldButton';
import fieldCustomCheckbox from './components/fields/fieldCustomCheckbox';
import fieldCustomChecklist from './components/fields/fieldCustomChecklist';
import fieldCustomInput from './components/fields/fieldCustomInput';
import fieldCustomTextArea from './components/fields/fieldCustomTextArea';
import fieldText from './components/fields/fieldText';
import fieldNewRow from './components/fields/fieldNewRow';
import fieldCustomRadios from './components/fields/fieldCustomRadios';
import fieldCustomSelect from './components/fields/fieldCustomSelect';
import fieldCustomSubmit from './components/fields/fieldCustomSubmit';
import fieldDuration from './components/fields/fieldDuration';
import fieldFlatpickr from './components/fields/fieldFlatpickr';
import fieldFileUpload from './components/fields/fieldFileUpload';
import fieldCustomVueMultiSelect from './components/fields/fieldCustomVueMultiSelect';
import './assets/styles/main.scss';

configureCompat({
  // Vue 3 compat mode (Vue 2 behaviour with deprecation warnings during migration).
  MODE: 2,
});

Vue.use(VueModal, { dialog: true });

const app = createApp(App);

app.use(VueFormGenerator);

app.component('tabs', TabsCompat);
app.component('tab', Tab);
app.component('multiselect', Multiselect);
app.component('fieldButton', fieldButton);
app.component('fieldCustomCheckbox', fieldCustomCheckbox);
app.component('fieldCustomChecklist', fieldCustomChecklist);
app.component('fieldCustomInput', fieldCustomInput);
app.component('fieldCustomTextArea', fieldCustomTextArea);
app.component('fieldText', fieldText);
app.component('fieldNewRow', fieldNewRow);
app.component('fieldCustomRadios', fieldCustomRadios);
app.component('fieldCustomSelect', fieldCustomSelect);
app.component('fieldCustomSubmit', fieldCustomSubmit);
app.component('fieldDuration', fieldDuration);
app.component('fieldFlatpickr', fieldFlatpickr);
app.component('fieldFileUpload', fieldFileUpload);
app.component('fieldCustomVueMultiSelect', fieldCustomVueMultiSelect);
app.component('ThemedButton', ThemedButton);

app.use(store);
app.use(router);

app.config.globalProperties.pluralize = pluralize;
app.config.globalProperties.axios = http;
app.config.globalProperties.$modal = Vue.prototype.$modal;

app.mount('#app');
